<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  [style]="{ width: '400px' }"
  styleClass="notification-dialog rounded-lg shadow-lg"
>
  <div class="flex flex-col items-center justify-center p-6 text-center">
    <!-- Ícono -->
    <i
      class="pi mb-4"
      [ngClass]="icon"
      [ngStyle]="isTailwindColor(iconColor) ? { 'font-size': iconSize } : { 'font-size': iconSize, 'color': iconColor }"
      [class]="isTailwindColor(iconColor) ? iconColor : ''"
    ></i>

    <!-- Mensaje -->
    <div class="mb-6">
      <p class="text-gray-900 text-xxl leading-6 whitespace-pre-line">{{ message }}</p>
    </div>

    <div class="flex justify-center w-full">
      <button
        pButton
        type="button"
        [label]="buttonLabel"
        (click)="onConfirm()"
        [class]="'p-button ' + buttonClass"
        class="px-6 py-2 text-sm"
      ></button>
    </div>
  </div>
</p-dialog>
